export default __webpack_public_path__ + "static/1151-859643c8e1d4ce57df3887dd570b10ef.gif";